import * as Yup from "yup";

const validationSchema = Yup.object().shape({
  adiNumber: Yup.string()
    .matches(/^(\s*|\d+)$/, "This field should not contain special characters")
    .required("This field is required"),
  mobileNumber: Yup.string()
    .matches(/^(\s*|\d+)$/, "This field should not contain special characters")
    .required("This field is required"),
});

export default validationSchema;
